import React from 'react';
import './App.css';
import {
    ComponentsPage,
    LoginPage,
    UserProfilePage,
    ComponentDetailPage,
    CoursesPage,
    CourseDetail,
    SetNewPasswordPage,
    CourseDraftsPage,
    CourseDraftDetail,
    SubmissionsInboxPage,
    AdminUsersPage,
    AdminCoursesPage,
} from './modules';
import { Button, Result } from 'antd';
import { BrowserRouter as Router, Routes, Link, Route } from 'react-router-dom';

import PrivateRoute from './modules/common/PrivateRoute';
import AdminRoute from './modules/common/AdminRoute';
import LoginLayout from './modules/Layout/LoginLayout';
import MainLayout from './modules/Layout/MainLayout';
import { useTranslation } from 'react-i18next';

const App = () => {
    const { t } = useTranslation();
    return (
        <Router>
            <div className="App">
                <Routes>
                    <Route
                        path="/"
                        element={
                            <LoginLayout>
                                <LoginPage />
                            </LoginLayout>
                        }
                    />
                    <Route
                        path="/app"
                        element={
                            <LoginLayout>
                                <LoginPage />
                            </LoginLayout>
                        }
                    />
                    <Route
                        path="/app/profile"
                        element={
                            <PrivateRoute>
                                <MainLayout>
                                    <UserProfilePage />
                                </MainLayout>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/app/profile/password/reset/:uid64/:token"
                        element={
                            <LoginLayout>
                                <SetNewPasswordPage />
                            </LoginLayout>
                        }
                    />
                    <Route
                        path="/app/courses"
                        element={
                            <PrivateRoute>
                                <MainLayout>
                                    <CoursesPage />
                                </MainLayout>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/app/course-drafts"
                        element={
                            <PrivateRoute>
                                <MainLayout>
                                    <CourseDraftsPage />
                                </MainLayout>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/app/course-drafts/:courseDraftId"
                        element={
                            <PrivateRoute>
                                <MainLayout>
                                    <CourseDraftDetail />
                                </MainLayout>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/app/courses/:courseId"
                        element={
                            <PrivateRoute>
                                <MainLayout>
                                    <CourseDetail />
                                </MainLayout>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/app/course-components"
                        element={
                            <PrivateRoute>
                                <MainLayout>
                                    <ComponentsPage />
                                </MainLayout>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/app/course-components/:componentId"
                        element={
                            <PrivateRoute>
                                <MainLayout>
                                    <ComponentDetailPage />
                                </MainLayout>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/app/submission-inbox/"
                        element={
                            <PrivateRoute>
                                <MainLayout>
                                    <SubmissionsInboxPage />
                                </MainLayout>
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/app/admin/users"
                        element={
                            <AdminRoute>
                                <MainLayout>
                                    <AdminUsersPage />
                                </MainLayout>
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="/app/admin/courses"
                        element={
                            <AdminRoute>
                                <MainLayout>
                                    <AdminCoursesPage />
                                </MainLayout>
                            </AdminRoute>
                        }
                    />
                    <Route
                        path="*"
                        element={
                            <Result
                                status="404"
                                title="404"
                                subTitle={t('page not found')}
                                extra={
                                    <Button type="primary">
                                        <Link to={'/'}>{t('going back')}</Link>
                                    </Button>
                                }
                            />
                        }
                    />
                </Routes>
            </div>
        </Router>
    );
};

export default App;
